// extracted by mini-css-extract-plugin
export default {"main":"_3ae0a14093","tit":"a316a3a6c7","maintitle":"_59c2e9769b","ylw":"b50132d7de","white":"_369aa31b15","mv_title":"a28af805ea","mv_nc":"_1d1da9138e","mv_in":"_613770f75b"};